import { Routes, Route } from "react-router-dom";
import PaymentButtonProcess from "./views/PaymentButtonProcess";
import "./App.css";

function App() {
  return (
    <Routes>
      <Route path="/" element={<PaymentButtonProcess />} />
    </Routes>
  );
}

export default App;
